/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { PureComponent } from 'react'
import { Theme } from '@themes/theme'

const Color = (theme: Theme) => css`
  width: inherit;
  height: auto;
  path {
    &.fill-1 {
      fill: ${theme.color.matchTit1};
    }
    &.fill-2 {
      fill: ${theme.color.themeTxt};
    }
    &.fill-3 {
      fill: ${theme.color.modalyellow};
    }
  }
`
export default class SendbetCouponIco extends PureComponent {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="34.5" height="34" viewBox="0 0 34.5 34" css={Color}>
        <g id="그룹_5874" data-name="그룹 5874" transform="translate(-5600.5 4883)">
          <rect id="사각형_4880" data-name="사각형 4880" width="34" height="34" transform="translate(5601 -4883)" fill="red" opacity="0"/>
          <path id="빼기_1" className="fill-1" data-name="빼기 1" d="M24.634,16.3H2.816A2.823,2.823,0,0,1,0,13.469V2.826A2.824,2.824,0,0,1,2.822,0H24.633V.01a1.856,1.856,0,0,1,1.854,1.844v1.54a2.4,2.4,0,0,0-.411,1.066h-.924a2.289,2.289,0,0,0-2.287,2.286v.706a2.7,2.7,0,0,0-.075.707,2.61,2.61,0,0,0,.075.7v1.1a2.289,2.289,0,0,0,2.287,2.287h.924a2.376,2.376,0,0,0,.4,1.051v1.155A1.846,1.846,0,0,1,24.634,16.3Z" transform="translate(5601 -4874)" fill="#294c72" stroke="rgba(0,0,0,0)" strokeMiterlimit="10"
                strokeWidth="1"/>
          <path id="패스_4966" className="fill-2" data-name="패스 4966" d="M672.486,387.754a.338.338,0,0,0,.337.326h2.748c1.911,0,3.357-.768,3.362-2.431a1.9,1.9,0,0,0-1.622-1.959v-.056a1.873,1.873,0,0,0,1.184-1.786c0-1.544-1.35-2.037-3.127-2.041h-2.523a.338.338,0,0,0-.337.322h0Zm1.737-4.577v-2.1h1.027c1.041,0,1.556.292,1.553,1.019,0,.659-.481,1.083-1.579,1.081Zm-.006,3.633v-2.4h1.2c1.192,0,1.824.337,1.822,1.144,0,.859-.646,1.263-1.825,1.262Z" transform="translate(4935.119 -5249.674)" fill="#fff"/>
          <path id="패스_4967" className="fill-2" data-name="패스 4967" d="M684.207,380.16a.662.662,0,0,1-.662-.662h0v-1.528a.662.662,0,0,1,1.324,0V379.5a.662.662,0,0,1-.661.663Z" transform="translate(4935.119 -5249.674)" fill="#fff"/>
          <path id="패스_4968" className="fill-2" data-name="패스 4968" d="M684.207,385.626a.663.663,0,0,1-.662-.662v-2.279a.662.662,0,0,1,1.324,0v2.279A.662.662,0,0,1,684.207,385.626Z" transform="translate(4935.119 -5249.674)" fill="#fff"/>
          <path id="패스_4969" className="fill-2" data-name="패스 4969" d="M684.207,390.344a.662.662,0,0,1-.662-.662h0v-1.528a.662.662,0,1,1,1.324,0v1.528a.662.662,0,0,1-.661.663Z" transform="translate(4935.119 -5249.674)" fill="#fff"/>
          <path id="빼기_2" className="fill-3" data-name="빼기 2" d="M5.583,9.96h0a.39.39,0,0,1-.388-.384v-1.7H2.287A.287.287,0,0,1,2,7.589V4.372a.287.287,0,0,1,.287-.286H5.193v-1.7A.39.39,0,0,1,5.572,2h.019a.338.338,0,0,1,.26.109L9.61,5.7l.689-.724-.675.737a.386.386,0,0,1-.014.548L5.851,9.852A.385.385,0,0,1,5.583,9.96Z" transform="translate(5623.864 -4871.627)" fill="#ea8902" stroke="rgba(0,0,0,0)" strokeMiterlimit="10" strokeWidth="1"/>
        </g>
      </svg>

    )
  }
}
